const accessToken = process.env.REACT_APP_API_REQUEST_ACCESS_TOKEN;

///////////////////////////// MemeVerse Feed ///////////////////////////////////
export const getHomeFeed = async (authUserId: string, numPosts: number, numComments: number, pageNumber: number, orderBy?: "recent" | "trending") => {
  orderBy ||= "recent";
  let queryParams = [
    `number_of_posts=${numPosts}`,
    `number_of_comments=${numComments}`,
    `page_no=${pageNumber}`,
    `order_by=${orderBy}`
  ].join('&')
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/home_feed?` + queryParams;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getNewsFeed = async (authUserId: string, limit: number, numComments: number, pageNumber: number) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts?user_id=${process.env.REACT_APP_SOOPRA_NEWS_ID || 'LvOfCYkJxYlLfT8hQmlK'}&limit=${limit}&page=${pageNumber}&comment_limit=${numComments}&direction=descending`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getFollowingFeed = async (authUserId: string, limit: number, pageNo: number) => {
  let queryParams = [
    `user_id=${authUserId}`,
    `limit=${limit}`,
    `page=${pageNo}`
  ].join('&')
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts/get_post_by_following?` + queryParams;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

/////////////////////////////// Meme Posts /////////////////////////////////////
export const createPost = async (authUserId: string, content: string, images?: (File | string)[]) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts`;
  var myHeaders = new Headers();
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const formData = new FormData();
  formData.append('user_id', authUserId);
  formData.append('content', content);

  const fileImages: File[] = [];
  const urlImages: string[] = [];

  images?.forEach((image) => {
    if (image instanceof File) {
      fileImages.push(image);
    } else if (typeof image === 'string') {
      urlImages.push(image);
    }
  });

  fileImages.forEach((file) => formData.append('images', file));

  if (urlImages.length) {
    formData.append('images', urlImages.join(','));
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: formData,
  };

  return fetch(apiURL, requestOptions);
};

export const getPostDetails = async (authUserId: string, postId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts?post_id=${postId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getPostsByUser = async (authUserId: string, userId: string, limit: number, page: number) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts?user_id=${userId}&limit=${limit}&page=${page}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const updatePost = async (authUserId: string, postId: string, content: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts?post_id=${postId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    content: content,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'PUT',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

export const deletePost = async (authUserId: string, postId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts?post_id=${postId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'DELETE',
  };

  return fetch(apiURL, requestOptions);
}

export const getUsersMyPosts = async (authUserId: string, userId: string, limit: number, page: number) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts?user_id=${userId}&limit=${limit}&page=${page}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getUsersMyReplies = async (authUserId: string, userId: string, limit: number, page: number) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}/api/memeverse/get_user_replied_post?user_id=${userId}&limit=${limit}&page=${page}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  const resp = fetch(apiURL, requestOptions);
  return resp;
}

export const generateMemes = async (userId: string, contentBody: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/generate_meme`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);

  const reqinfo = {
    user_id: userId,
    content_body: contentBody,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

export const incrementViewOnPost = async (authUserId: string, postId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/meme-posts/increment_watch`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    post_id: postId,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

///////////////////////////// Meme Comments ////////////////////////////////////
export const createCommentOnPost = async (authUserId: string, postId: string, content: string, mentions?: string[]) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    user_id: authUserId,
    commenter_type: "user",
    content: content,
    post_id: postId,
  }

  if (mentions && mentions.length) {
    reqinfo["mentioned_users"] = mentions;
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

export const createCommentOnComment = async (commentId: string, postId: string, userId: string, content: string, mentions?: string[]) => {

  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (userId) myHeaders.append('x-user-handler-token', userId)

  const reqinfo = {
    user_id: userId,
    commenter_type: "user",
    content: content,
    comment_id: commentId,
    post_id: postId,
  }

  if (mentions && mentions.length) {
    reqinfo["mentioned_users"] = mentions;
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

export const getCommentDetails = async (authUserId: string, commentId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment?comment_id=${commentId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getCommentsOnPost = async (authUserId: string, postId: string, limit: number, page: number) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment?post_id=${postId}&page=${page}&limit=${limit}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getCommentsByUser = async (authUserId: string, userId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment?user_id=${userId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const updateComment = async (authUserId: string, commentId: string, content: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment?comment_id=${commentId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    comment: content,
    commenter_type: 'user',
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'PUT',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

export const deleteComment = async (authUserId: string, commentId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment?comment_id=${commentId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'DELETE',
  };

  return fetch(apiURL, requestOptions);
}

export const incrementViewOnComment = async (authUserId: string, commentId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment/increment_watch`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    comment_id: commentId,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  // return fetch(apiURL, requestOptions);
  return null;
}

//////////////////////////////// Post Likes ////////////////////////////////////
export const createPostlike = async (authUserId: string, postId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/post_likes`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    user_id: authUserId,
    post_id: postId,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

export const getPostLikes = async (authUserId: string, postId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/post_likes?post_id=${postId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getPostLikesByUser = async (authUserId: string, userId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/post_likes?user_id=${userId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getPostLikesByUserOnPost = async (authUserId: string, postId: string, userId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/post_likes?user_id=${userId}&post_id=${postId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

// export const deletePostLike = async (userId: string, likeId: string) => {
//   const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/post_likes?like_id=${likeId}`;
//   var myHeaders = new Headers();
//   myHeaders.append('Content-Type', 'application/json');
//   myHeaders.append('x-access-token', accessToken);
//   if (userId) myHeaders.append('x-user-handler-token', userId)

//   const requestOptions: RequestInit = {
//     headers: myHeaders,
//     method: 'DELETE',
//   };

//   return fetch(apiURL, requestOptions);
// }

// export const deletePostLikeByUser = async (postId: string, userId: string) => {
//   const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/post_likes?user_id=${userId}&post_id=${postId}`;
//   var myHeaders = new Headers();
//   myHeaders.append('Content-Type', 'application/json');
//   myHeaders.append('x-access-token', accessToken);
//   if (userId) myHeaders.append('x-user-handler-token', userId)

//   const requestOptions: RequestInit = {
//     headers: myHeaders,
//     method: 'DELETE',
//   };

//   return fetch(apiURL, requestOptions);
// }


//////////////////////////////// Comment Likes ////////////////////////////////////
export const createCommentLike = async (authUserId: string, commentId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment_likes`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    user_id: authUserId,
    comment_id: commentId,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

// export const getCommentLikes = async (userId: string, commentId: string) => {
//   const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment_likes?comment_id=${commentId}`;
//   var myHeaders = new Headers();
//   myHeaders.append('Content-Type', 'application/json');
//   myHeaders.append('x-access-token', accessToken);
//   if (userId) myHeaders.append('x-user-handler-token', userId)

//   const requestOptions: RequestInit = {
//     headers: myHeaders,
//     method: 'GET',
//   };

//   return fetch(apiURL, requestOptions);
// }

export const getCommentLikesByUser = async (authUserId: string, userId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment_likes?user_id=${userId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

export const getCommentLikesByUserOnComment = async (authUserId: string, commentId: string, userId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment_likes?user_id=${userId}&comment_id=${commentId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}

// export const deleteCommentLike = async (likeId: string) => {
//   const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment_likes?like_id=${likeId}`;
//   var myHeaders = new Headers();
//   myHeaders.append('Content-Type', 'application/json');
//   myHeaders.append('x-access-token', accessToken);

//   const requestOptions: RequestInit = {
//     headers: myHeaders,
//     method: 'DELETE',
//   };

//   return fetch(apiURL, requestOptions);
// }

// export const deleteCommentLikeByUser = async (commentId: string, userId: string) => {
//   const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/comment_likes?user_id=${userId}&comment_id=${commentId}`;
//   var myHeaders = new Headers();
//   myHeaders.append('Content-Type', 'application/json');
//   myHeaders.append('x-access-token', accessToken);

//   const requestOptions: RequestInit = {
//     headers: myHeaders,
//     method: 'DELETE',
//   };

//   return fetch(apiURL, requestOptions);
// }

/////////////////////////////////// Follow /////////////////////////////////////
export const followCreator = async (authUserId: string, creatorId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/user_follow`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    user_id: authUserId,
    follow_user_id: creatorId,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}



///////////////////////////// MemeVerse User Search ///////////////////////////////////
export const getMemeverseUsers = async (authUserId: string, query: string, pageNumber: number, pageSize: number) => {

  let queryParams = [
    `query=${query}`,
    `page=${pageNumber}`,
    `pageSize=${pageSize}`
  ].join('&')
  const apiURL = `${process.env.REACT_APP_API_END_POINT}search/ask_users?` + queryParams;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}
